<div class="category">
    <h3>{{ category.name }}</h3>
    <!-- <img [src]="category.image" alt="{{ category.name }}"> -->
     <div *ngIf="category.subcategories.length">
      <div *ngFor="let subcategory of category.subcategories">
        <app-category-card [category]="subcategory"></app-category-card>
      </div>
    </div>
  </div>
  